import blockJSON from './block.json';
import $ from 'jquery';

function setUrlParam( key, value ) {
	if ( history.pushState ) {
		let searchParams = new URLSearchParams( window.location.search );
		searchParams.set( key, value );
		let newurl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			'?' +
			searchParams.toString();
		window.history.pushState(
			{
				path: newurl
			},
			'',
			newurl
		);
	}
}

function openDay( evt, date ) {

	// Declare all variables
	var i, tabcontent, tablinks;

	// Get all elements with class="tabcontent" && hide them
	tabcontent = document.getElementsByClassName( 'mec-agenda-events-wrap' );
	for ( i = 0; i < tabcontent.length; i++ ) {
		tabcontent[i].className = tabcontent[i].className.replace( ' active', '' );
	}

	// Get all elements with class="tablinks" && remove the class "active"
	tablinks = document.getElementsByClassName( 'mec-agenda-date-wrap' );
	for ( i = 0; i < tablinks.length; i++ ) {
		tablinks[i].className = tablinks[i].className.replace( ' active', '' );
	}

	// Show the current tab, && add an "active" class to the button that opened the tab
	document.getElementById( date ).className += ' active';
	evt.currentTarget.className += ' active';

	// update url for reload
	setUrlParam( 'date', date );
}
window.openDay = openDay;

function isGutenbergActive() {
	return document.body.classList.contains( 'block-editor-page' );
}
function getDefaultBlockAtts( attributes ) {
	const defaults = {};

	Object.keys( attributes ).forEach( ( key ) => {
		defaults[key] = attributes[key].default;
	});

	return defaults;
}

function getAgendaAttrsData() {
	const sliderDataSelector = '#agenda-attrs-data';

	const dataEl = $( sliderDataSelector );
	let sliderData;
	try {
		sliderData = JSON.parse( dataEl.text() );
	} catch ( error ) {
		sliderData = dataEl.text();
	}

	const DEFAULT_ATTS = getDefaultBlockAtts( blockJSON.attributes );
	const data = { ...sliderData };
	data.atts = sliderData.atts ? sliderData.atts : DEFAULT_ATTS;

	return data;
}

// Function to handle form changes
function updateSearchForm() {
	const data = getAgendaAttrsData();

	console.log( 'Data', data );

	// Get selected values from the dropdowns
	let selectedCategory = $( '#mec_sf_category_' ).val();
	let selectedLocation = $( '#mec_sf_location_' ).val();
	let searchTerm = $( '#mec_sf_s_' ).val();

	let options = data.options;

	options.category = selectedCategory;
	options.location = selectedLocation;
	options.search = searchTerm;

	// Prepare data to send to the server
	let requestData = {
		options,
		atts: data.atts
	};

	// Make an AJAX request to update the search form based on selected options
	$.ajax({
		url: '/hope/wp-json/ae-mec-agenda-block/v1/search_form_updated', // WordPress AJAX URL
		type: 'POST',
		data: requestData,
		success: function( response ) {
			console.log( 'Res Searc', response );

			// Assuming response contains the updated HTML
			$( '.ae-mec-block-agenda  > .events' ).remove();
			$( '.ae-mec-block-agenda  > .tabs' ).remove();
			$( '.ae-mec-block-agenda' ).append( response.tabs );

			$( response.events ).insertAfter( '.ae-mec-block-agenda .tabs' );
		},
		error: function( xhr, status, error ) {
			console.log( 'Error:', error );
		}
	});
}

// Function to reset all filters
function resetSearchForm() {

	// Reset the dropdowns to their default values
	$( '#mec_sf_category_' ).val( '' ); // Reset the category dropdown
	$( '#mec_sf_location_' ).val( '' ); // Reset the location dropdown
	$( '#mec_sf_s_' ).val( '' ); // Reset the search input

	// Trigger the updateSearchForm function to fetch default data
	updateSearchForm();
}

$( window ).on( 'load', function() {
	console.log( 'loading' );

	// Attach change event handlers to the dropdowns and search input
	$( '#mec_sf_category_' ).on( 'change', updateSearchForm );
	$( '#mec_sf_location_' ).on( 'change', updateSearchForm );
	$( '#mec_sf_s_' ).on( 'input', updateSearchForm );

	$( '#mec_search_form__reset' ).on( 'click', resetSearchForm );
});
